import React from "react";
import dayjs from "dayjs";

import Constants from "../../../utils/constants";
import { incrementFormatCounter, round } from "../../../utils/tools";

const styles = {
  document: {
    color: "#000000",
    fontFamily: "sans-serif",
    fontSize: "9pt",
  },
  logo: {
    marginBottom: "10pt",
    textAlign: "center",
  },
  addressTable: {
    border: "none",
    borderCollapse: "collapse",
    marginBottom: "16pt",
    width: "100%",
  },
  addressCell: {
    border: "none",
    padding: "2pt 4pt",
    verticalAlign: "top",
  },
  title: {
    fontSize: "16pt",
    margin: "40pt 0 30pt",
    textAlign: "center",
  },
  metadata: {
    marginBottom: "4pt",
    textAlign: "left",
  },
  lots: {
    marginTop: "18pt",
    marginBottom: "18pt",
    textAlign: "left",
  },
  mentions: {
    fontSize: "7pt",
    margin: "10pt 0 16pt",
    textAlign: "justify",
  },
  sectionTable: {
    borderCollapse: "collapse",
    fontSize: "8pt",
    marginTop: "16pt",
    marginBottom: "16pt",
    width: "100%",
  },
  sectionHeader: {
    backgroundColor: "#8eaadb",
    border: "1px solid #D3D3D3",
    padding: "4pt",
    textAlign: "center",
    verticalAlign: "middle",
  },
  columnHeader: {
    backgroundColor: "#e6e6e6",
    border: "1px solid #D3D3D3",
    padding: "3pt",
    textAlign: "left",
    verticalAlign: "middle",
  },
  centerHeader: {
    backgroundColor: "#e6e6e6",
    border: "1px solid #D3D3D3",
    padding: "3pt",
    textAlign: "center",
    verticalAlign: "middle",
  },
  cell: {
    border: "1px solid #D3D3D3",
    padding: "3pt",
    verticalAlign: "top",
  },
  amountCell: {
    border: "1px solid #D3D3D3",
    padding: "3pt",
    textAlign: "right",
    verticalAlign: "top",
    whiteSpace: "nowrap",
  },
  totalLabelCell: {
    backgroundColor: "#d9e2f3",
    border: "1px solid #D3D3D3",
    padding: "3pt",
    textAlign: "right",
    verticalAlign: "top",
  },
  totalAmountCell: {
    backgroundColor: "#d9e2f3",
    border: "1px solid #D3D3D3",
    padding: "3pt",
    textAlign: "right",
    verticalAlign: "top",
    whiteSpace: "nowrap",
  },
};

const formatCurrency = (value) =>
  parseFloat(value).toLocaleString("fr-FR", {
    style: "currency",
    currency: "EUR",
  });

const HonorairePdf = ({ dateButoir, ligneReddition, numeroFacture = 1, utilisateur }) => {
  const societe = utilisateur.utilisateur_societe;

  const chemin = `${Constants.mode}://${Constants.domain}:${Constants.port}/api/societe/display/${societe.societe_id}`;

  let width = 200;
  let height = 30;

  if (societe.societe_logo_width) width = societe.societe_logo_width;
  if (societe.societe_logo_height) height = societe.societe_logo_height;

  const factureDate = dateButoir
    ? dayjs(dateButoir, "DD/MM/YYYY").format("DD/MM/YYYY")
    : dayjs().format("DD/MM/YYYY");

  const reference = incrementFormatCounter(
    parseInt(societe.invoice_counter, 10) + numeroFacture - 1
  );

  let lots = [];

  const totalHonoraires = ligneReddition.montantFrais;
  const honorairesHT = round(totalHonoraires / 1.2, 2);
  const honorairesTVA = totalHonoraires - honorairesHT;

  return (
    <div style={styles.document}>
      {/* ADRESSE CABINET */}
      <div style={styles.logo}>
        <img src={chemin} width={width} height={height} alt="" />
      </div>

      {/* ADRESSE PROPRIETAIRE */}
      <div>
        <table style={styles.addressTable}>
          <tbody>
            <tr>
              <td width="55%" style={styles.addressCell}>
                <strong>{societe.societe_raison_sociale}</strong>
                <br />
                {societe.societe_adresse.adresse_numero} {societe.societe_adresse.adresse_voie}
                <br />
                {societe.societe_adresse.adresse_secteur}
                <br />
                {societe.societe_adresse.adresse_code_postal}{" "}
                {societe.societe_adresse.adresse_ville}
              </td>
              <td width="45%" style={styles.addressCell}></td>
            </tr>
            <tr>
              <td width="55%" style={styles.addressCell}></td>
              <td width="45%" style={styles.addressCell}>
                <strong>
                  {ligneReddition.proprietaire.personne_qualite.qualite_libelle}{" "}
                  {ligneReddition.proprietaire.personne_nom}{" "}
                  {ligneReddition.proprietaire.personne_prenom}
                </strong>
                <br />
                {ligneReddition.proprietaire.personne_adresse.adresse_numero}{" "}
                {ligneReddition.proprietaire.personne_adresse.adresse_voie}
                <br />
                {ligneReddition.proprietaire.personne_adresse.adresse_secteur}
                <br />
                {ligneReddition.proprietaire.personne_adresse.adresse_code_postal}{" "}
                {ligneReddition.proprietaire.personne_adresse.adresse_ville}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div style={styles.title}>
        <strong>FACTURE D'HONORAIRES DE GESTION LOCATIVE</strong>
      </div>

      <div style={styles.metadata}>
        {societe.societe_adresse.adresse_ville}
        {", le "}
        {dayjs().format("DD/MM/YYYY")}
      </div>
      <div style={styles.lots}>
        {ligneReddition.locations.length > 0 &&
          ligneReddition.locations.map((location, i) => {
            if (!lots.some((lot) => lot.lot_id === location.location_lot.lot_id)) {
              lots.push(location.location_lot);
              return (
                <div key={i} style={styles.metadata}>
                  <i>
                    {`Lot n°${location.location_lot.lot_reference}
              ${
                location.location_lot.lot_designation
                  ? "(" + location.location_lot.lot_designation + ")"
                  : ""
              }:
              ${location.location_lot.lot_adresse.adresse_gmaps_adresse}`}
                  </i>
                </div>
              );
            }
            return null;
          })}
      </div>

      <div style={styles.metadata}>
        <i>Facture N° : {reference}</i>
      </div>
      <div style={styles.metadata}>
        <i>Période arrêtée au {factureDate}</i>
      </div>

      {/*<div style={styles.mentions}>
        Facture émise par <strong>{societe.societe_raison_sociale}</strong>,{" "}
        {societe.societe_zone_libre_1}, dont le siège social est situé{" "}
        {societe.societe_adresse.adresse_gmaps_adresse}, {societe.societe_zone_libre_2}, titulaire
        de la carte professionnelle {societe.societe_zone_libre_3},{" "}
        {societe.societe_zone_libre_4}, {societe.societe_zone_libre_5}.
      </div>*/}

      <table style={styles.sectionTable}>
        <thead>
          <tr>
            <th colSpan="2" style={styles.sectionHeader}>
              <strong>HONORAIRES DE GESTION LOCATIVE</strong>
            </th>
          </tr>
          <tr>
            <th width="70%" style={styles.columnHeader}>
              <strong>LIBELLE</strong>
            </th>
            <th width="30%" style={styles.centerHeader}>
              <strong>MONTANT</strong>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td width="70%" style={styles.cell}>
              Honoraires HT
            </td>
            <td width="30%" style={styles.amountCell}>
              {formatCurrency(honorairesHT)}
            </td>
          </tr>
          <tr>
            <td width="70%" style={styles.cell}>
              TVA sur honoraires (20%)
            </td>
            <td width="30%" style={styles.amountCell}>
              {formatCurrency(honorairesTVA)}
            </td>
          </tr>
          <tr>
            <td width="70%" style={styles.totalLabelCell}>
              <strong>TOTAL TTC</strong>
            </td>
            <td width="30%" style={styles.totalAmountCell}>
              <strong>{formatCurrency(totalHonoraires)}</strong>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default HonorairePdf;
